import { MapType } from '.././enums/map-type.enum';

export class MapProviderType {

  public type: MapType;

  constructor(type: MapType) {
    this.type = type;
  }

}
